import React, { useEffect, useRef, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import apiCalls from "../../../../config/apiCalls";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useNavigate, useParams } from "react-router";
import "./SideBySideLayout.css";
import { useSearchParams } from "react-router-dom";
import Modules from "./Modules";

// config file

const TestCaseGenerator = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [rolesList, setRolesList] = useState([]);
  const [gotRoles, setgotRoles] = useState(false);
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);
  const [searchParams] = useSearchParams();
  const moduleId = searchParams.get("module");
  const navigate = useNavigate();


  const [modules, setModules] = useState([]);

  const params = useParams();

  useEffect(() => {
    getRoleListFromServer();
    fetchModules();
    let screenPermissions = RolePermissions.screenPermissions("Test Cases");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
  }, []);




  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };
  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };


  const getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest("GET", url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = [];
          for (let obj of res.roles) {
            if (obj.role) rolesList.push({ value: obj.role, label: obj.role });
          }
          setRolesList(rolesList);
          setgotRoles(true);
        }
      })
      .catch((err) => {
        setgotRoles(true);
        return err;
      });
  };
  const getTableFields = () => {
    const priorityTypes = [
      { label: "All", value: null, color: "secondary" },
      { label: "High", value: "High", color: "danger" },
      { label: "Medium", value: "Medium", color: "success" },
      { label: "Low", value: "Low", color: "warning" },
    ];

    const roleTypes = [
      { label: "All", value: null },
      { label: "Admin", value: "Admin" },
      { label: "Manager", value: "Manager" },
      { label: "Guest", value: "Guest" },
    ];

    const categoryTypes = [
      { label: "All", value: null, color: "secondary" },
      { label: "Functional", value: "Functional", color: "success" },
      { label: "User Interface (UI)", value: "UI", color: "primary" },
      { label: "Integration", value: "Integration", color: "info" },
      { label: "System", value: "System", color: "warning" },
      { label: "Acceptance (UAT)", value: "UAT", color: "success" },
      { label: "Security", value: "Security", color: "danger" },
      { label: "Regression", value: "Regression", color: "secondary" },
      { label: "Compatibility", value: "Compatibility", color: "info" },
    ];

    let data = [
      // {
      //   textAlign: "center",
      //   width: "60px",
      //   field: "Check Box",
      //   label: "Check Box",
      //   fieldType: "multiple",
      //   header: "",
      //   selectionMode: "multiple",
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   displayinlist: "false",
      //   displayinaddForm: "false",
      //   displayineditForm: "false",
      //   globalSearchField: "false",
      //   isFieldRequired: "false",
      //   tDisplay: true,
      // },
      // {
      //   textAlign: "center",
      //   width: "60px",
      //   field: "Sno",
      //   label: "SNo",
      //   header: "SNo",
      //   sortable: false,
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      //   tDisplay: true,
      // },
      {
        name: "testCaseID",
        type: "text",
        placeholder: "Test Case ID",
        label: "Test Case ID",
        width: "120px",
        header: "Test Case ID",
        sortable: true,
        filter: true,
        textAlign: "left",
        show: true,
        field: "testCaseID",
        fieldType: "text",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        tDisplay: true,
        style: {
          textAlign: "center",
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflowWrap: "anywhere"

        }
      },
      {
        name: "title",
        type: "text",
        placeholder: "Title",
        label: "Title",
        width: "250px",
        header: "Scenario",
        sortable: true,
        filter: true,
        textAlign: "left",
        field: "title",
        show: true,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        required: true,
        globalSearchField: "true",
        displayInSettings: true,
        tDisplay: true,
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflowWrap: "anywhere"
        }
      },
      {
        name: "category",
        type: "dropDown",
        placeholder: "Category",
        label: "Category",
        header: "Category",
        field: "category",
        options: categoryTypes,
        width: "120px",
        textAlign: "center",
        show: true,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        tDisplay: true,
        sortable: true,
        filter: true,
        style: {
          textTransform: 'uppercase'
        }
      },
      {
        name: "description",
        type: "textarea",
        placeholder: "Description",
        label: "Description",
        width: "300px",
        header: "Description",
        field: "description",
        show: true,
        textAlign: "left",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        required: false,
        displayInSettings: true,
        tDisplay: true,
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflowWrap: "anywhere"
        }
      },
      {
        name: "preconditions",
        type: "textarea",
        placeholder: "Preconditions",
        label: "Preconditions",
        width: "250px",
        header: "Preconditions",
        field: "preconditions",
        show: true,
        textAlign: "left",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "false",
        required: false,
        displayInSettings: true,
        tDisplay: true,
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflowWrap: "anywhere"
        }
      },
      {
        name: "steps",
        type: "ckeditor",
        placeholder: "Steps",
        label: "Steps",
        width: "250px",
        header: "Steps",
        field: "steps",
        show: false,
        textAlign: "left",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "false",
        required: false,
        displayInSettings: true,
        fieldType: "customType",
        customFieldType: 'innerHTML',
        tDisplay: true,
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflowWrap: "anywhere"
        }
      },
      {
        name: "expectedResult",
        type: "textarea",
        placeholder: "Expected Result",
        label: "Expected Result",
        width: "300px",
        header: "Expected Result",
        field: "expectedResult",
        show: true,
        textAlign: "left",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "false",
        required: false,
        displayInSettings: true,
        tDisplay: true,
        style: {
          whiteSpace: "normal",
          wordWrap: "break-word",
          overflowWrap: "anywhere"
        }
      },
      // {
      //   name: "roles",
      //   type: "dropDown",
      //   placeholder: "Roles",
      //   label: "Roles",
      //   header: "Roles",
      //   field: "roles",
      //   options: roleTypes,
      //   width: "140px",
      //   textAlign: "center",
      //   show: true,
      //   displayinaddForm: "true",
      //   displayineditForm: "true",
      //   displayinlist: "true",
      //   globalSearchField: "true",
      //   required: true,
      //   displayInSettings: true,
      //   fieldType: "dropDown",
      //   tDisplay: true,
      // },
      {
        name: "priority",
        type: "dropDown",
        placeholder: "Priority",
        label: "Priority",
        header: "Priority",
        field: "priority",
        options: priorityTypes,
        width: "120px",
        textAlign: "center",
        show: true,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        globalSearchField: "true",
        required: true,
        displayInSettings: true,
        fieldType: "dropDown",
        tDisplay: true,
        sortable: true,
        filter: true,
        style: {
          textTransform: 'uppercase'
        }
      },
      {
        show: true,
        textAlign: "center",
        width: "80px",
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinlist: "true",
        displayinaddForm: "true",
        displayineditForm: "true",
        globalSearchField: "false",
        isFieldRequired: "false",
        mobile: true,
        tDisplay: true,
      },
    ];

    return data;
  };


  const getFormFields = () => {
    let priorityTypes = [
      { label: "High", value: "High" },
      { label: "Medium", value: "Medium" },
      { label: "Low", value: "Low" },
    ];

    let roleTypes = [
      { label: "Admin", value: "Admin" },
      { label: "Manager", value: "Manager" },
      { label: "Guest", value: "Guest" },
    ];

    const categoryTypes = [
      { label: "All", value: null, color: "secondary" },
      { label: "Functional", value: "Functional", color: "success" },
      { label: "User Interface (UI)", value: "UI", color: "primary" },
      { label: "Integration", value: "Integration", color: "info" },
      { label: "System", value: "System", color: "warning" },
      { label: "Acceptance (UAT)", value: "UAT", color: "success" },
      { label: "Security", value: "Security", color: "danger" },
      { label: "Regression", value: "Regression", color: "secondary" },
      { label: "Compatibility", value: "Compatibility", color: "info" },
    ];


    return [
      {
        show: true,
        name: "prompt",
        value: "",
        type: "textarea",
        placeholder: "Prompt",
        label: "Prompt",
        id: "prompt",
        width: 300,
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "false",
        required: true,
        rows: "3",
        globalSearchField: "true",
        fieldType: "textarea",
        isAddFormHidden: true,
        isEditFormHidden: true,
        showInRegenerateForm: true,
        editInRegenerateForm: true,
      },
      {
        show: true,
        name: "testCaseID",
        type: "text",
        placeholder: "Test Case ID",
        label: "Test Case ID",
        value: "",
        id: "testCaseID",
        width: 100,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        required: true,
        globalSearchField: "true",
        fieldType: "text",
        isAddFormHidden: false,
        isEditFormHidden: false,
        showInRegenerateForm: true,
        editInRegenerateForm: false,
      },
      {
        show: true,
        name: "title",
        type: "text",
        value: "",
        placeholder: "Title",
        label: "Title",
        id: "title",
        width: 250,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        required: true,
        globalSearchField: "true",
        fieldType: "text",
        isAddFormHidden: false,
        isEditFormHidden: false,
        showInRegenerateForm: true,
        editInRegenerateForm: false,
      },
      {
        show: true,
        name: "description",
        value: "",
        type: "textarea",
        placeholder: "Description",
        label: "Description",
        id: "description",
        width: 300,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        required: true,
        rows: "3",
        globalSearchField: "true",
        fieldType: "textarea",
        isAddFormHidden: false,
        isEditFormHidden: false,
        showInRegenerateForm: true,
        editInRegenerateForm: false,
      },
      {
        show: true,
        name: "preconditions",
        value: "",
        type: "textarea",
        placeholder: "Preconditions",
        label: "Preconditions",
        id: "preconditions",
        width: 250,
        rows: "3",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        required: false,
        globalSearchField: "false",
        fieldType: "textarea",
        isAddFormHidden: false,
        isEditFormHidden: false,
        showInRegenerateForm: true,
        editInRegenerateForm: false,
      },
      {
        show: true,
        name: "steps",
        value: "",
        type: "ckeditor",
        placeholder: "Steps",
        label: "Steps",
        id: "steps",
        width: 300,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        required: true,
        globalSearchField: "false",
        fieldType: "ckeditor",
        isAddFormHidden: false,
        isEditFormHidden: false,
        showInRegenerateForm: false,
        editInRegenerateForm: false,
      },
      {
        show: true,
        name: "expectedResult",
        type: "textarea",
        value: "",
        placeholder: "Expected Result",
        label: "Expected Result",
        id: "expectedResult",
        width: 300,
        rows: "3",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        required: true,
        globalSearchField: "false",
        fieldType: "textarea",
        isAddFormHidden: false,
        isEditFormHidden: false,
        showInRegenerateForm: true,
        editInRegenerateForm: false,
      },
      {
        show: true,
        name: "moduleId",
        type: "text",
        value: moduleId,
        placeholder: "Module Id",
        label: "Module Id",
        id: "moduleId",
        width: 300,
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "false",
        required: false,
        globalSearchField: "false",
        fieldType: "textarea",
        isAddFormHidden: true,
        isEditFormHidden: true,
        showInRegenerateForm: false,
        editInRegenerateForm: false,
      },
      {
        show: true,
        name: "filePath",
        type: "text",
        value: "",
        placeholder: "File Path",
        label: "File Path",
        id: "filePath",
        width: 300,
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "false",
        required: false,
        globalSearchField: "false",
        fieldType: "textarea",
        isAddFormHidden: true,
        isEditFormHidden: true,
        showInRegenerateForm: false,
        editInRegenerateForm: false,
      },
      {
        show: true,
        name: "priority",
        type: "dropDown",
        placeholder: "Priority",
        label: "Priority",
        id: "priority",
        width: 120,
        options: priorityTypes,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        required: true,
        globalSearchField: "false",
        fieldType: "dropDown",
        isAddFormHidden: false,
        isEditFormHidden: false,
        showInRegenerateForm: true,
        editInRegenerateForm: false,
      },
      {
        show: true,
        name: "category",
        type: "dropDown",
        placeholder: "Category",
        label: "Category",
        id: "category",
        width: 120,
        options: categoryTypes,
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        required: true,
        globalSearchField: "false",
        fieldType: "dropDown",
        isAddFormHidden: false,
        isEditFormHidden: false,
        showInRegenerateForm: true,
        editInRegenerateForm: false,
      },
    ];
  };

  const getChangedRoleOptions = () => {
    let fields = getFormFields();
    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name == "role") {
          obj.options = rolesList && rolesList.length > 0 ? rolesList : [];
        }
      }
    }
    return fields;
  };


  const displayName = () => {
    if (modules && modules.length > 0) {
      let selectedModule = modules.find((mod) => mod._id === moduleId);
      return selectedModule ? selectedModule.moduleName : "";
    }
  }

  const fetchModules = () => {
    fetchMethodRequest('GET', apiCalls.modules).then((response) => {
      if (response.testCasesModules) {
        let moduleData = response.testCasesModules.map((module) => ({
          moduleName: module.moduleName,
          _id: module._id,
          count: module.count || 0,
          description: module.description || "",
        }));
        setModules(moduleData);
        if (!moduleId) navigate(`?module=${moduleData[0]._id}`);
      }
    });
  }


  return (
    <div className="layout-wrapper">
      <div className="side-by-side-container">
        <div className="main-content row">
          <Modules modules={modules} setModules={setModules} fetchModules={fetchModules} />
          {modules && modules.length > 0 ? <div className="col-md-9 col-lg-9">
            {gotRoles && (
              <DataTables
                {...props}
                getTableFields={getTableFields}
                formFields={getChangedRoleOptions}
                //
                addRequired={
                  // rolePermission && rolePermission == "Edit" ? true : false
                  false
                }
                editRequired={
                  rolePermission && rolePermission == "Edit" ? true : false
                }
                deleteRequired={
                  rolePermission && rolePermission == "Edit" ? true : false
                }
                viewRequired={
                  rolePermission && rolePermission == "Edit" ? true : false
                }
                exportRequired={
                  rolePermission && rolePermission == "Edit" ? true : false
                }
                sample={true}
                // actionsTypes={[
                //   {
                //     name: "Delete",
                //     options: [
                //       {
                //         label: "Delete",
                //         value: "Delete",
                //         show:
                //           rolePermission && rolePermission == "Edit" ? true : false,
                //         multiple: true,
                //       },
                //     ],
                //   },
                // ]}
                settingsRequired={true}
                filterRequired={false}
                gridRequried={false}
                exportToCsv={true}
                dateSearchRequired={undefined}
                searchInDateRangeField={"undefined"}
                sampleFilePath={filePath.testCases}
                setData={setData}
                editSelectedRecord={editSelectedRecord}
                addSelectedRecord={addSelectedRecord}
                viewSelectedRecord={viewSelectedRecord}
                globalSearch={
                  "Search "
                }
                displayName={displayName()}
                type="testCase"
                routeTo={apiCalls.testCases}
                sideFormLeftOrRight="right"
                displayViewOfForm="sideForm"
                apiResponseKey={apiCalls.testCases}
                apiUrl={apiCalls.testCases}
                selectedId={params.id}
                buttonToolTips={{ add: 'Add Test Cases' }}
                softUpdate={true}
                softDelete={true}
                actionOverlayPanel={false}
                fetchModules={fetchModules}
              />
            )}
          </div> : <div className="col-md-9 col-lg-9 d-flex align-items-center justify-content-center">
            <div
              className="text-center p-5 rounded-3"
              style={{
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: "1.6",
                width: "80%",
                minHeight: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Please create a Module to start generating test cases.
            </div>
          </div>}
        </div>


      </div>
    </div>
  );

};

export default TestCaseGenerator;
